// Add your JS customizations here
(function () { if ( 'undefined' !== typeof jQuery ) {

	jQuery.fn.outside = function(ename, cb){
		return this.each(function(){
			var $this = jQuery(this),
				self = this;

			jQuery(document.body).bind(ename, function tempo(e){

				if(e.target !== self && !jQuery.contains(self, e.target)){
					cb.apply(self, [e]);
					if(!self.parentNode) $(document.body).unbind(ename, tempo);
				}
			});
		});
	};

	jQuery.fn.scrollFocus  = function() {

		var scrollPosition = ( this[0].getBoundingClientRect()['top'] - document.body.getBoundingClientRect()['top'] - 150 );
		jQuery( 'html,body' ).animate({'scrollTop': scrollPosition}, 500 );

		return this;
	};



	jQuery.fn.sautSelect = function ( args ){

		const $ = jQuery.noConflict();

		const sautSelect = {
			$assembly: null,
			assemblyWrapperClass: 'saut-custom-select',
			selectSelector: 'select',
			wrapperClass: 'saut-select-element-wrapper',
			newSelectClass: 'saut-select-element',
			newSelectPlaceholderClass: 'saut-select-element-placeholder',
			newSelectPlaceholderText: null,
			optionContainerClass: 'options-container',
			optionClass: 'options-value',
			checkLocationHash: false,
			init: function( element, args ) {

				args.assemblyWrapperClass		&&	(sautSelect.assemblyWrapperClass		= args.assemblyWrapperClass);
				args.selectSelector				&&	(sautSelect.selectSelector				= args.selectSelector);
				args.wrapperClass				&&	(sautSelect.wrapperClass				= args.wrapperClass);
				args.newSelectClass				&&	(sautSelect.newSelectClass				= args.newSelectClass);
				args.newSelectPlaceholderClass	&&	(sautSelect.newSelectPlaceholderClass	= args.newSelectPlaceholderClass);
				args.newSelectPlaceholderText	&&	(sautSelect.newSelectPlaceholderText	= args.newSelectPlaceholderText);
				args.optionContainerClass		&&	(sautSelect.optionContainerClass		= args.optionContainerClass);
				args.optionClass				&&	(sautSelect.optionClass					= args.optionClass);
				args.checkLocationHash			&&	(sautSelect.checkLocationHash			= args.checkLocationHash);

				sautSelect.$assembly = $( element );

				sautSelect.$assembly.each( sautSelect.initAssembly );

				return sautSelect;
			},

			initAssembly: function() {

				const $assembly = $(this);

				if ( null === sautSelect.newSelectPlaceholderText ) {

					sautSelect.newSelectPlaceholderText = sautSelect.$assembly.children(sautSelect.selectSelector).data('placeholder');

					if ( 'undefined' === typeof sautSelect.newSelectPlaceholderText ) {

						sautSelect.newSelectPlaceholderText = sautSelect.$assembly.children(sautSelect.selectSelector).children('[value=""]').first().text();
					}
				}


				$assembly.find( sautSelect.selectSelector ).each(function() {

					const $this = $(this);

					const $selectElementWrap = $('<div class="' + sautSelect.wrapperClass + '"><div class="' + sautSelect.newSelectPlaceholderClass + '">' + sautSelect.newSelectPlaceholderText + '</div><div class="' + sautSelect.newSelectClass + '"></div></div>')
						.appendTo( $this.parent() );

					const $optionsContainer = $('<div class="' + sautSelect.optionContainerClass + '"></div>')
						.appendTo($selectElementWrap);

					const $selectElement = $selectElementWrap.children( '.' + sautSelect.newSelectClass );

					$this.children().each( function() {

						if ( this.value ) {
							$optionsContainer.append('<div class="' + sautSelect.optionClass + '" data-value="' + this.value + '"><span>' + $(this).text() + '</span></div>')
						}
					});

					$selectElement.text( $this.children('[value="' + this.value + '"]').text());

					if ( '' === this.value ) {

						$selectElement.addClass( 'option-placeholder' );
					}

					if ( sautSelect.checkLocationHash && window.location.hash && $this.children( '[data-controls="' + window.location.hash.substr(1) + '"]').length ) {

						$selectElement.text( $this.children( '[data-controls="' + window.location.hash.substr(1) + '"]').text());
					}

					$selectElementWrap.outside('click', sautSelect.hideThisOptions );

					$this.css({'opacity': '0','position':'relative','z-index': '-1'});

					$this.on('change', sautSelect.updateDisplayedValue );
				});

				$assembly.on('click', '.' + sautSelect.newSelectClass, sautSelect.toggleSautSelect );

				$assembly.on('click', '.' + sautSelect.optionClass, sautSelect.selectSautSelectOption );

				$assembly.on('click', '.' + sautSelect.newSelectPlaceholderClass, function(e){ $(this).closest( '.' + sautSelect.wrapperClass.replaceAll( ' ', '.') ).toggleClass( 'show' ); } );

			},

			updateDisplayedValue: function(e) {

				const $select = $(this),
					$wrap = $select.closest('.' + sautSelect.assemblyWrapperClass ),
					$selectElement = $wrap.find('.' + sautSelect.newSelectClass );

				$selectElement.text( $select.find('option[value="' + $select.val() + '"]').text() );


				if ( '' === this.value ) {

					$selectElement.addClass( 'option-placeholder' );
				} else {

					$selectElement.removeClass( 'option-placeholder' );
				}
			},

			showOptions: function($this) {


			},

			hideOptions: function($this) {

				$this.removeClass('show');
			},

			hideThisOptions: function(e) {

				$(this).removeClass('show');
			},

			toggleSautSelect: function(e) {

				const $this = $(this),
					$wrapper = $this.closest('.' + sautSelect.wrapperClass.replaceAll( ' ', '.'));

				$wrapper.toggleClass('show');

				if ($wrapper.hasClass('show')) {

					sautSelect.showOptions( $wrapper );
				} else {

					sautSelect.hideOptions( $wrapper );
				}
			},

			selectSautSelectOption: function(e) {

				const $this = $(this),
					$wrap = $this.closest('.' + sautSelect.assemblyWrapperClass ),
					$select = $wrap.children( sautSelect.selectSelector ),
					$selectElement = $wrap.find('.' + sautSelect.newSelectClass ),
					$selectElementWrap = $wrap.find('.' + sautSelect.wrapperClass.replaceAll( ' ', '.') );


				$select.val( $this.data('value') ).trigger('change' );

				$selectElement.text( $this.text() );

				sautSelect.hideOptions( $selectElementWrap );
			}
		}

		return sautSelect.init( this, args );
	}

	jQuery(document).ready( function() {

		jQuery('.saut-custom-select').sautSelect({
			assemblyWrapperClass: 'saut-custom-select',
			selectSelector: 'select',
			wrapperClass: 'saut-select-element-wrapper',
			newSelectClass: 'saut-select-element',
			newSelectPlaceholderClass: 'saut-select-element-placeholder',
			optionContainerClass: 'options-container',
			optionClass: 'options-value',
			checkLocationHash: true
		});

		jQuery('.wpcf7-form-control-wrap').sautSelect({
			assemblyWrapperClass: 'wpcf7-form-control-wrap',
			selectSelector: 'select',
			wrapperClass: 'wpcf7-saut-select saut-select-element-wrapper',
			newSelectClass: 'saut-select-element',
			newSelectPlaceholderClass: 'saut-select-element-placeholder',
			optionContainerClass: 'options-container',
			optionClass: 'options-value',
			checkLocationHash: false
		});
	} );

	(function ($){

		let oldScrollPosition = 0;

		$(document).on('scroll', function(e) {

			let newScrollPosition = $(window).scrollTop();

			if ( newScrollPosition < oldScrollPosition ) {

				$( document.body ).addClass('scroll-up');
			} else if ( newScrollPosition > oldScrollPosition ) {

				$( document.body ).removeClass('scroll-up');
			}

			oldScrollPosition = newScrollPosition;

			if( newScrollPosition >= 50 ) {

				$(document.body).addClass('header--sticked');
			} else {

				$(document.body).removeClass('header--sticked');
				$(document.body).removeClass('scroll-up');
			}
		})


		$( document ).on( 'mouseenter click', '#navbarNavDesktop > ul > li > a', function(e) {

			if ( e.type === 'mouseenter' ) {

				$( '#navbarNavDesktop > ul' ).find( '.dropdown-toggle.show' ).each( function(){

					$( this )
						.removeClass( 'show' )
						.attr( 'aria-expanded', 'false' )
						.siblings( '.dropdown-menu.show')
							.removeClass( 'show' )
							.removeAttr( 'data-bs-popper' );

				});
			}

			var $this = $( this );

			var $menuItem = $this.parent();

			document.activeElement.blur();

			$menuItem.siblings().removeClass('show-dropdown');
			$menuItem.addClass('show-dropdown');

			$('#wrapper-navbar').addClass('show-menu');
		});


		$( document ).on( 'click', '#wrapper-navbar', function(e) {

			if ( (! $(e.target).hasClass('dropdown-toggle nav-link') ) ) {

				var $header = $( this );

				$header.removeClass('show-menu');
				$header.find( '.navbar-primary-desktop > ul > li' ).removeClass('show-dropdown');
			}
		});

		$( document ).on( 'mouseleave', '#main-desktop-nav', function() {

			var $header = $( '#wrapper-navbar' );

			$header.removeClass('show-menu');
			$header.find( '.navbar-primary-desktop > ul > li' ).removeClass('show-dropdown');
		});

		$( document ).on( 'click', '#main-mobile-nav .navbar-toggler', function() {

			triggerMobileMenuContentsChange('open');
		});

		$( document ).on( 'click', '#navbarNavOffcanvas .btn-close', function() {

			triggerMobileMenuContentsChange('close');

			setTimeout( function(){$(this).blur(); $('#main-mobile-nav .navbar-toggler').blur();}, 300 );
		});

		window.triggerMobileMenuContentsChange = function (action) {

			if( window.isMobile.any ) {

				return true;
			}

			$('#main-menu-desktop').html('');
			$('#main-menu-mobile').html('');

			$( (action === 'open') ? '#main-menu-mobile' : '#main-menu-desktop' ).html( window.sautMenu );
		}

		function saut_actualites_resize_texts() {
			$('.content-block-actualites').find('.actualites__list_item:nth-child(2n)').each(function () {
				const $left = jQuery(this).prev().find( '.actualites__list_item_text' ), $right = jQuery(this).find( '.actualites__list_item_text' ), leftHeight = $left.height(), rightHeight = $right.height(); if( leftHeight < rightHeight ){ $left.height( $right.height() ) } else { $right.height( $left.height() ) }
			})
		}

		$(document).on('click','.winners-button,.billetterie-button',function(e){dataLayer.push({'event':'trackEvent','eventCategory':'Minisite_SAUT','eventAction':'click_button','eventLabel':this.text})});

		$(document).ready( function(){

			window.sautMenu = $('#main-menu-desktop').html();

			if( ( 'undefined' !== typeof window.isMobile ) && window.isMobile.any ) {

				$( '#main-menu-desktop' ).html('');

				$( '#main-menu-mobile' ).html( window.sautMenu );
			}

			function accordion_toggle() {

				if( window.location.hash ){
					if( ($( window.location.hash + ".content-block-accordion" ).length > 0) && ($( window.location.hash + ".content-block-accordion .accordion-collapse:not(.show)").length > 0) ) {
						$(".accordion-collapse").collapse("hide");
						setTimeout( function(){$( window.location.hash + ".content-block-accordion .accordion-collapse").collapse("show");},400);
					}

					var scrollTarget = document.getElementById( window.location.hash.replace( '#', '' ) );
					var scrollTo = ( scrollTarget.getBoundingClientRect()['top'] - document.body.getBoundingClientRect()['top'] - 100 );
					$([document.documentElement, document.body]).animate( {scrollTop: scrollTo }, 300 );
				}
			}

			if ( $(".content-block-accordion").length > 0 ) {

				/*if ((window.location.hash === "") || ($(window.location.hash + ".content-block-accordion").length === 0)) {

					$(".content-block-accordion").first().find(".accordion-collapse").collapse("show")
				}*/


				accordion_toggle();
			}

			$('#scrolltop-button').on('click', function(){ $('html,body').animate({'scrollTop': 0}, 200 ); setTimeout( function(){ $('body').removeClass('scroll-up')}, 300);});

			$( '.wpcf7' ).on( 'wpcf7submit', function( event ) {

				const scrollTo = ( $( '.wpcf7-form')[0].getBoundingClientRect()['top'] - document.body.getBoundingClientRect()['top'] - 200 );

				$('html,body').animate({'scrollTop': scrollTo }, 200 );
			} );

			$('#saut-language-chooser-dropdown').hover( function( e ) { $(this).children('.saut-languages-dropdown').slideDown() }, function( e ) { $(this).children('.saut-languages-dropdown').slideUp() } )

			$('#main-menu-desktop > li').each( function(e){ const $this = $(this); $this.css('max-height', parseInt( $this.children('.nav-link' ).first().outerHeight() ) + parseInt( $this.children('.dropdown-menu').first().outerHeight() ) + 'px' )			} );

			if ( $('.content-block.content-block-programmes').length ) {
				$(document).on( 'change', '.saut-programmes-dropdown-tablist', function(e){ $('#'+$(this).val()).trigger('click'); });
				$(document).on( 'shown.bs.tab', function(e){ $(e.target).closest( '.content-block-programmes' ).find( '.saut-programmes-dropdown-tablist').val( e.target.id ).trigger('change'); });
			}

			if ( $('.saut-mediatheque-dropdown-tablist').length ) {
				$(document).on( 'change', '.saut-mediatheque-dropdown-tablist', function(e){ $('#'+$(this).children( '[value="' + $(this).val() + '"]' ).data( 'controls' ) ).trigger('click'); })
			}

			if ( $('.content-block-actualites').length ) { $(window).on( 'resize', saut_actualites_resize_texts ); saut_actualites_resize_texts(); }

			if ( $('.mediatheque-tabs').length ) {

				$('.mediatheque-tabs').each( function() {

					$(this).on( 'click', '.mediatheque-tab', function(e) {

						const $tab = $(this),
							  $tabs= $tab.closest('.mediatheque-tabs-wrapper');

						$tabs.find('.saut-select-element').text( $tab.text() );
						$tabs.find('.saut-mediatheque-dropdown-tablist').val( $tabs.find('option[data-controls="' + $tab.attr('id' ) + '"]') );

						window.location.hash = $tab.find('button').attr('id');
					});

					if ( window.location.hash ) {

						$(this).find('.nav-link').each(function () {

							if (window.location.hash === ('#' + $(this).attr('id'))) {

								$(this).trigger('click');
							}
						});
					}
				});
			}

			$('.mea_editorial__legend-mobile').each( function(){ const $this = $(this); $this.parent().siblings().first().css( 'padding-bottom', 'calc( ' + $this.outerHeight() +'px + ' + $this.css( 'margin-top' ) + ')')});

			jQuery('.page-title-wrapper .page-title').addClass('animated');
		} );

	})(jQuery);

}})();


